<template>
  <b-card no-body>
    <b-card-body>
      <customer-parameter-detail
        ref="customerUserDetail"
        type="new"
        :submitting="submitting"
        @submit="submit"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { BCard, BCardBody } from 'bootstrap-vue';
import { helper } from '@core/mixins/helper';
import useService from '@/auth/service/useService';
import CustomerParameterDetail from '@/views/pages/customers/CustomerParameterDetail.vue';

export default {
  components: {
    BCard,
    BCardBody,
    CustomerParameterDetail
  },
  mixins: [helper],
  data() {
    return {
      submitting: false,
      data: {}
    };
  },
  methods: {
    submit(data) {
      this.submitting = true;
      useService
        .createCustomerParameter({ ...data, customer_id: this.$route.params.id })
        .then(response => {
          // this.$refs.customerUserDetail.resetForm()
          this.showSuccessMessage(`${response.message}`);
          this.$router.push({
            name: 'customers_parameters_list',
            params: { id: this.$route.params.id }
          });
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
